import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { EntityService } from '@services/entity/entity.service';
import { Observable } from 'rxjs';
import { PayoutStatementTableData } from '@dto/payoutStatementTableData';
import { PayoutAmountDue } from '@dto/payoutAmountDue';

@Injectable({
  providedIn: 'root'
})
export class PayoutStatementsService extends EntityService {
  public entityRoute = "payout-statements";

  constructor
  (
    http: HttpClient,
    @Inject('BASE_URL') baseUrl: string
  ) {
    super(http, baseUrl);
  }

  getPayoutStatementsAsTableData(): Observable<PayoutStatementTableData[]> {
    return this.http.get<PayoutStatementTableData[]>(`${this.baseUrl}api/payoutstatements/tabledata`);
  }

  getCustomerPayoutStatementsAsTableData(customerUserId: number): Observable<PayoutStatementTableData[]> {
    return this.http.get<PayoutStatementTableData[]>(`${this.baseUrl}api/payoutstatements/tabledata/${customerUserId}`);
  }

  downloadPayoutStatement(id: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}api/payoutstatements/download/${id}`, { responseType: 'blob' as 'json'});
  }
  
  getPayoutAmountDue(customerUserId: string) {
    return this.http.get<PayoutAmountDue>(`${this.baseUrl}api/payoutstatements/payout/due/${customerUserId}`);
  }
  
  payout(userId: string) {
    return this.http.get<number>(`${this.baseUrl}api/payoutstatements/payout/${userId}`);
  }
}
